import type { IconProps } from '../icons';

import React from 'react';

import clsx from 'clsx';

import { Link } from '../Link';
import { Typography } from '../Typography';
import { Icon } from '../icons';

type OverviewCardProps = {
  text: string;
  title: string;
  icon: IconProps;
  buttonLabel: React.ReactNode;
  href: string;
};

const OverviewCard = ({
  text,
  title,
  icon,
  href,
  buttonLabel
}: OverviewCardProps) => (
  <div
    className={clsx(
      'flex p-4 border border-solid border-gray-200 rounded-lg',
      'shadow-md'
    )}
  >
    <div className={'flex flex-col h-full w-full'}>
      <div
        className={
          'rounded-full w-10 p-2 bg-blue-100 shadow-[0_0_0_4px_#EFF4FF]'
        }
      >
        <Icon {...icon} />
      </div>
      <Typography fontFace={'BodyBoldLg'} className={'mt-3'}>
        {title}
      </Typography>

      <Typography
        fontFace={'BodyRegularMd'}
        className={'pt-2 flex-grow mb-auto'}
      >
        {text}
      </Typography>

      <Link className={'mt-8 mb-auto'} color={'secondary'} href={href}>
        {buttonLabel}
      </Link>
    </div>
  </div>
);

export { OverviewCard };
export type { OverviewCardProps };
